const FREE_EMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'yahoo.com',
  'yahoo.fr',
  'hotmail.com',
  'hotmail.fr',
  'outlook.com',
  'outlook.fr',
  'live.com',
  'live.fr',
  'msn.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'proton.me',
  'protonmail.com',
  'mail.com',
  'gmx.com',
  'gmx.fr',
  'yandex.com',
  'yandex.ru',
  'zoho.com',
  'free.fr',
  'orange.fr',
  'laposte.net',
  'sfr.fr',
  'wanadoo.fr',
])

export function isValidEmailFormat(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())
}

export function isProfessionalEmail(email: string): boolean {
  const normalized = email.trim().toLowerCase()
  if (!isValidEmailFormat(normalized)) return false

  const domain = normalized.split('@')[1]
  return !FREE_EMAIL_DOMAINS.has(domain)
}

export function getEmailDomain(email: string): string | null {
  const normalized = email.trim().toLowerCase()
  if (!isValidEmailFormat(normalized)) return null
  return normalized.split('@')[1]
}
